<template>
    <div class="game_info">
        <van-overlay :show="infoShow">
            <div class="game_info_wrapper">
                <img src="@/assets/images/game/close.png" @click="goback" class="game_info_wrapper_close" />
                <div class="game_info_wrapper_pic">
                    游戏失败
                </div>
                 <img src="@/assets/images/game/three/woman/2.png" class="game_info_wrapper_cry" />
                <p>{{infoMsg}}</p>
                <div class="game_info_wrapper_button">
                     <div class="game_info_wrapper_button_no" @click="goback">
                         返回关卡
                     </div>
                     <div class="game_info_wrapper_button_yes" @click="restart">
                         重新开始
                     </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
export default {
    name: 'fall-info',
    props:['infoShow','infoMsg'],
    data () {
        return {

        }
    },
    methods:{
        restart() {
            this.$emit('restart');
        },
        goback() {
            this.$emit('goback');
        },
    }
}
</script>
<style lang='scss' scoped>
.van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    .game_info_wrapper {
        width: 248px;
        height: 173px;
        background: url(./../../assets/images/game/fail-bg.png);
        background-size: cover;
        position: relative;
        .game_info_wrapper_close {
            position: absolute;
            width: 26px;
            height: 26px;
            right: -10px;
            top: -10px;
        }
        .game_info_wrapper_cry {
            width: 45px;
            height: 46px;
            margin-left: 101px;
            margin-top: 15px;
        }
        .game_info_wrapper_pic {
            width: 182px;
            height: 49px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 44px;
            background: url(./../../assets/images/game/fail.png);
            background-size: cover;
            margin-left: 33px;
            margin-top: -30px;
        }
        p {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            text-align: center;
            margin-top: 10px;
        }
        .game_info_wrapper_button {
            display: flex;
            justify-content: center;
            margin-top: 10px;
            .game_info_wrapper_button_no {
                width: 86px;
                height: 31px;
                background: url(./../../assets/images/game/no.png);
                background-size: cover;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 31px;
                text-shadow: 0px 2px 1px #6381FF;
                text-align: center;
            }
            .game_info_wrapper_button_yes {
                width: 86px;
                height: 31px;
                background: url(./../../assets/images/game/yes.png);
                background-size: cover;
                margin-left: 12px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 31px;
                text-shadow: 0px 2px 1px #fe8c62;
                text-align: center;
            }
        }
    }
}

</style>
